<style scoped>
.layout {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f7f9;
}
.layout .header {
  width: 100%;
  height: 60px;
  min-width: 1090px;
  background-color: #fff;
  position: fixed;
  z-index: 999;
  top: 0px;
  left: 0px;
}
.layout .layout-header {
  width: 100%;
  height: 60px;
  display: block;
  position: relative;
}
.layout-logo {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 5px;
  left: 20px;
}
.layout-avator {
  width: 240px;
  height: 36px;
  float: right;
  position: absolute;
  top: 12px;
  right: 20px;
}
.layout-avator .avator {
  width: 36px;
  height: 36px;
  border-radius: 18px;
  margin: 0px 10px;
}
.layout-avator .tooltip {
  margin-left: 20px;
  margin-right: 10px;
}
.layout-avator .username {
  color: #69aa46;
  width: 80px;
  display: inline-block;
  word-break: keep-all;
  vertical-align: middle;
  text-align: right;
}
.layout-logo .ivu-btn-text:focus {
  box-shadow: none;
}
.layout-nav {
  width: 350px;
  height: 30px;
  line-height: 30px;
  font-size: 22px;
  color: #333;
  padding: 15px 0px;
  margin: 0px auto;
  box-sizing: content-box;
}
.layout-nav i {
  width: 33px;
  height: 33px;
  display: inline-block;
  background: url("../assets/newLoge.png") center no-repeat;
  background-size: 100%;
  vertical-align: middle;
}
.layout-assistant {
  width: 300px;
  margin: 0 auto;
  height: inherit;
}
.layout-breadcrumb {
  padding: 10px 15px 0;
}
.layout-content {
  height: 100%;
  padding-top: 70px;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
}
.layout-main {
  height: 100%;
  display: block;
  position: relative;
}
.layout-main-left {
  height: 100%;
  background: #464c5b;
  overflow-y: scroll;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  transition: width 0.3s;
}
.layout-main-left::-webkit-scrollbar {
  display: none;
}
.layout-main-right {
  height: 100%;
  width: 100%;
  display: flex;
  transition: padding 0.3s;
  box-sizing: border-box;
}
.layout-menu {
  width: 100%;
  height: 100%;
}
.layout-content-main {
  flex: 1;
  overflow-y: scroll;
}
.layout-hide-text .layout-text {
  display: none;
}
.ivu-col {
  transition: width 0.2s ease-in-out;
}
</style>
<template>
  <div class="layout">
    <div class="header">
      <div class="layout-header">
        <div class="layout-logo">
          <Button type="text" @click="toggleClick">
            <Icon type="navicon" size="32"></Icon>
          </Button>
        </div>
        <div class="layout-nav">
          <i class="logo"></i>
          陕西省保健学会信息管理系统
        </div>
        <div class="layout-avator">
          <Row type="flex" justify="end" align="middle">
            <Tooltip
              :content="
                message > 0 ? '有' + message + '条未读消息' : '无未读消息'
              "
              placement="top"
            >
              <Badge :count="message" dot>
                <Icon type="ios-bell" size="22"></Icon>
              </Badge>
            </Tooltip>
            <Tooltip
              :content="
                message > 0 ? '有' + message + '条未读消息' : '无未读消息'
              "
              placement="top"
              class="tooltip"
            >
              <Badge :count="message" dot>
                <Icon type="chatbox-working" size="22"></Icon>
              </Badge>
            </Tooltip>
            <Avatar :src="avatar" class="avator"></Avatar>
            <Dropdown transfer trigger="click" @on-click="handleDropdown">
              <a href="javascript:void(0)">
                <span class="username oneline">{{ userName }}</span>
                <Icon type="arrow-down-b" color="#69aa46"></Icon>
              </a>
              <DropdownMenu slot="list">
                <DropdownItem name="loginout">退出登录</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Row>
        </div>
      </div>
    </div>
    <div class="layout-content" :class="{ 'layout-hide-text': spanLeft < 5 }">
      <div class="layout-main">
        <div
          class="layout-main-left"
          :style="{ width: shrink ? '100px' : '230px' }"
        >
          <div class="layout-menu">
            <Menu
              :active-key="activeName"
              :open-keys="openNames"
              width="auto"
              :theme="menuTheme"
              @on-select="handleChange"
              @on-open-change="handleExpand"
            >
              <MenuItem
                  key="homepage"
                  name="homepage"
                >
                  <Icon
                    type="paperclip"
                    :size="iconSize"
                    key="iconhomepage"
                  ></Icon>
                  <span class="layout-text" key="titlehomepage">
                    首页
                  </span>
              </MenuItem>
              <template v-for="item in menuList">
                <MenuItem
                  v-if="(item.child.length <= 1&&right.indexOf(item.child[0].name)!=-1)"
                  :key="item.child[0].name"
                  :name="item.child[0].name"
                >
                  <Icon
                    :type="item.icon"
                    :size="iconSize"
                    :key="'icon' + item.name"
                  ></Icon>
                  <span class="layout-text" :key="'title' + item.name">{{
                    item.child[0].title
                  }}</span>
                </MenuItem>
                <Submenu
                  v-if="item.child.length > 1"
                  :key="item.name"
                  :name="item.name"
                >
                  <template slot="title">
                    <Icon :type="item.icon" :size="iconSize"></Icon>
                    <span class="layout-text">{{ item.title }}</span>
                  </template>
                  <template v-for="child in item.child">
                    <MenuItem
                      :key="child.name"
                      :name="child.name"
                      v-if="
                        right.some((v) => {
                          return v === child.name;
                        })
                      "
                    >
                      <Icon
                        :type="child.icon"
                        :key="'icon' + child.name"
                      ></Icon>
                      <span class="layout-text" :key="'title' + child.name">{{
                        child.title
                      }}</span>
                    </MenuItem>
                  </template>
                </Submenu>
              </template>
            </Menu>
          </div>
        </div>
        <div
          class="layout-main-right"
          :style="{ paddingLeft: shrink ? '100px' : '230px' }"
        >
          <div class="layout-content-main">
            <!--<keep-alive>-->
            <!--</keep-alive>-->
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Cookies from "js-cookie";
export default {
  name: "home",
  data() {
    return {
      token: "",
      spanLeft: 5,
      spanRight: 19,
      shrink: false,
      activeName: "homepage",
      openNames: ["officeWebsite", "information"],
      message: 0,
      menuTheme: "dark",
      username: "",
      password: "",
      refresh: false,
      right: [],
    };
  },
  computed: {
    iconSize() {
      return this.spanLeft === 5 ? 14 : 24;
    },
    menuList() {
      return this.$store.state.menuList;
    },
    userName() {
      if (this.$store.state.name != "") {
        return this.$store.state.name;
      }
      return localStorage.getItem("name");
    },
    avatar() {
      if (this.$store.state.avatar != "") {
        return this.$store.state.avatar;
      }
      return localStorage.getItem("avatar");
    },
  },
  methods: {
    getRight() {
      this.refresh = false;
      var id = localStorage.getItem("Groupid");
      if (id) {
        axios
        .get("https://api.lotusdata.com/operations/v1/competence/list/" + id, {
          headers: { Authorization: this.token },
        })
        .then((res) => {
          if (res.data.code === 0) {
            let routerName = this.$route.name
            var list = res.data.data.res_data;
            if (list != null) {
              this.right = [];
              for (let i in list) {
                let {Competence, DataCreate, DataDelete, DataExport, DataSelect, DataUpdate}  = list[i]
                if (Competence === routerName) {
                    console.log(Competence, routerName)
                    this.$store.commit("setDataUpdate", DataUpdate)
                    this.$store.commit("setDataCreate", DataCreate)
                    this.$store.commit("setDataDelete", DataDelete)
                    this.$store.commit("setDataExport", DataExport)
                    this.$store.commit("setDataSelect", DataSelect)
                }
                this.right.push(list[i].Competence);
              }
            } else {
              this.right = [];
            }
            setTimeout(() => {
              this.getDocument();
            }, 100);

            setTimeout(() => {
              this.refresh = true;
            }, 200);
          } else {
            this.$Message.error("身份获取失败请重新登录！");
            this.$store.commit("logout");
            this.$router.push({
              name: "login",
            });
          }
        });
      }

    },
    getDocument() {
      var menuWraper = document.getElementsByClassName("ivu-menu-submenu");
      let menuWrapers = document.getElementsByClassName("ivu-menu-item");
      for (var i = 0; i < menuWraper.length; i++) {
        if (menuWraper[i].children[1].children.length == 0) {
          menuWraper[i].style.display = "none";
        }
      }
    },
    toggleClick() {
      this.shrink = !this.shrink;
      if (this.spanLeft === 5) {
        this.spanLeft = 2;
        this.spanRight = 22;
      } else {
        this.spanLeft = 5;
        this.spanRight = 19;
      }
    },
    handleChange(name) {
      this.$router.push({
        name: name,
      });
      this.activeName = name;
      this.$store.commit("setActiveKey", this.activeName);
    },
    handleExpand(name) {
      this.openNames = name;
      this.$store.commit("setOpenList", this.openNames);
    },
    handleDropdown(name) {
      if (name === "loginout") {
        this.$store.commit("logout");
        this.$router.push({
          name: "login",
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      var open = localStorage.getItem("openlist");
      if (open != null) {
        this.openNames = open.split(",");
      }
      this.activeName = localStorage.getItem("activekey");
      this.token = localStorage.getItem("token");
      this.username = Cookies.get("username");
      this.password = Cookies.get("password");
      this.getRight();
    });
  },
  updated() {
    this.token = localStorage.getItem("token");
    this.username = Cookies.get("username");
    this.password = Cookies.get("password");
    if (this.username !== undefined && this.refresh) {
      this.getRight();
    }
  },
};
</script>
